import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import { CallbackCall as CallbackCallIcon } from '@icons/communication';
import { IncomingCall as IncomingCallIcon } from '@icons/communication';
import { OutgoingCall as OutgoingCallIcon } from '@icons/communication';
import { IncomingCallUnanswered as UnansweredIncomingCallIcon } from '@icons/communication';
import { OutgoingCallUnanswered as UnansweredOutgoingCallIcon } from '@icons/communication';

const TITLES = {
  CALL: 'Открыть звонок в админке',
  CALLBACK: 'Открыть коллбэк в админке',
};

const CallIcon = React.memo(
  ({ href, isActive, isAnswered, isCallback, isIncoming, ...restProps }) => {
    if (!(_.isBoolean(isAnswered) && _.isBoolean(isIncoming)) && !isCallback) {
      return null;
    }

    let Icon;
    if (isCallback) {
      Icon = CallbackCallIcon;
    } else if (isIncoming) {
      Icon =
        isActive || isAnswered ? IncomingCallIcon : UnansweredIncomingCallIcon;
    } else {
      Icon =
        isActive || isAnswered ? OutgoingCallIcon : UnansweredOutgoingCallIcon;
    }

    let title;
    if (href) {
      title = isCallback ? TITLES.CALLBACK : TITLES.CALL;
    }

    const [isHovered, setHovered] = useState(false);
    const enableHovered = () => setHovered(true);
    const disableHovered = () => setHovered(false);

    return (
      <StyledCallIcon
        href={href}
        isHovered={isHovered}
        onClick={disableHovered}
        onMouseEnter={enableHovered}
        onMouseLeave={disableHovered}
        target="_blank"
        title={title}
        {...restProps}
      >
        <Icon />
      </StyledCallIcon>
    );
  }
);

CallIcon.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  isActive: PropTypes.bool,
  isAnswered: PropTypes.bool,
  isCallback: PropTypes.bool,
  isIncoming: PropTypes.bool,
};

CallIcon.defaultProps = {
  className: '',
  href: null,
  isActive: false,
  isAnswered: null,
  isCallback: false,
  isIncoming: null,
};

const StyledCallIcon = styled.a`
  display: block;
  height: 20px;
  width: 20px;

  svg {
    height: 100%;
    width: 100%;
  }

  :hover {
    ${({ href, isHovered }) =>
      href &&
      isHovered &&
      `
      svg > * {
        fill: none;
        stroke: #007aff;
      }
    `}
  }
`;

export default CallIcon;
